import React, { HTMLProps } from 'react'

interface Props extends HTMLProps<HTMLDivElement> {
    className?:string
}

function WhiteContainer(props: Props) {
    const {children, className} = props

    return (
        <div className={`p-16px bg-white border border-E1E0E0  ${className}`}>
            {children}
        </div>
    )
}

export default WhiteContainer
